// RazorpayActivationNotice.jsx
import React, { useState, useEffect } from 'react';
import { RefreshCw, X } from 'lucide-react';

const RazorpayActivationNotice = ({ onClose }) => {
  const [visible, setVisible] = useState(true);
  
  useEffect(() => {
    // Set a timeout to automatically close after 2 minutes (120000 ms)
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, 120000);
    
    return () => clearTimeout(timer);
  }, [onClose]);
  
  if (!visible) return null;
  
  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md bg-[#1e293b] rounded-lg shadow-xl border border-blue-500 p-4 animate-fade-in">
      <div className="flex items-start">
        <div className="flex-shrink-0 mt-0.5">
          <RefreshCw className="h-5 w-5 text-[#ff7e00] animate-spin-slow" />
        </div>
        <div className="ml-3 flex-1 pr-6">
          <h3 className="text-sm font-medium text-white">Subscription Processing</h3>
          <p className="mt-1 text-sm text-gray-300">
            It might take a few minutes for your subscription to be fully activated. 
            If your subscription features are not immediately available, please refresh 
            the dashboard or check back in a few minutes.
          </p>
        </div>
        <button 
          onClick={() => {
            setVisible(false);
            if (onClose) onClose();
          }}
          className="absolute top-3 right-3 text-gray-400 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default RazorpayActivationNotice;